import { render } from "./Infantil.vue?vue&type=template&id=ec19a83c"
import script from "./Infantil.vue?vue&type=script&lang=js"
export * from "./Infantil.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__